import { DateService } from '@core/services/date.service';
import { DisneyUniversalParams } from './interfaces/disney_universa.interface';
import { Item } from './interfaces/item.interface';
import { EventItemParams } from './interfaces/item_params.interfeace';
import { Meal_plan } from './meal_plan.enum';
import { SearchStateService } from '@core/services';

export class EventItemParamsClass implements EventItemParams {
  public section = '-';
  public producto = '-';
  public dias = '-';
  public fechas = '-';
  public horas = '-';
  public anticipacion_de_compra = '-';
  public dias_de_producto = '-';
  public region_1 = '-';
  public plan_de_comida: Meal_plan;
  public cantidad_de_personas = '-';
  public servicios = '-';
  public recomendado: 'si' | 'no' = 'no';
  public cantidad_de_huespedes = '-';
  public cantidad_de_habitaciones = '-';
  public precio_por_edad = '-';
  public impuestos_tasas = '-';
  public logueo: 'si' | 'no' = 'no';
  public items: Item[] = [];
  private universal_city = 'new6280590';
  constructor(
    private searchService: SearchStateService,
    private dateService: DateService,
  ) {
    this.reload();
  }

  private getCountGuest(rooms: any[]) {
    let adults = 0;
    let children = 0;
    let babys = 0;
    rooms.forEach((room) => {
      adults += room.adults;
      if (room.childrenAges !== undefined) {
        children += (room.childrenAges as Array<any>).filter(
          (age) => age.value > 1,
        ).length;
        babys += room.childrenAges.filter((age) => age.value <= 1).length;
      }
    });
    return `${adults} // ${children} // ${babys}`;
  }

  public getData() {
    this.reload();
    const data = this.comunData();

    const dataByProvider = () => {
      if (data.producto === 'alojamiento') {
        return this.dataAlojamiento();
      } else {
        return this.dataDisneyUniversal();
      }
    };

    return {
      ...data,
      ...dataByProvider(),
    };
  }

  private comunData() {
    return {
      section: this.section,
      días: this.dias,
      fechas: this.fechas,
      horas: this.horas,
      anticipacion_de_compra: this.anticipacion_de_compra,
      dias_de_producto: this.dias_de_producto,
      plan_de_comida: this.plan_de_comida,
      cantidad_de_personas: this.cantidad_de_personas,
      servicios: this.servicios,
      cantidad_de_huespedes: this.cantidad_de_huespedes,
      cantidad_de_habitaciones: this.cantidad_de_habitaciones,
      precio_por_edad: this.precio_por_edad,
      impuestos_tasas: this.impuestos_tasas,
      logueo: this.logueo,
      items: this.items,
      producto: this.producto,
    };
  }

  public dataAlojamiento() {
    return {
      region: this.region_1,
      recomendado: this.recomendado,
    };
  }

  public dataDisneyUniversal(): DisneyUniversalParams {
    return {
      precio_pase: '-',
      precio_plan_comida: '-',
      id_anterior: '-',
    };
  }

  public createItems(hotelStatic?): Item[] {
    const itemsArray = [];
    return itemsArray;
  }

  private reload() {
    this.dias = ` ${this.dateService.getDay(
      this.searchService.date.split(',')[0],
    )} // ${this.dateService.getDay(this.searchService.date.split(',')[1])}`;
    this.fechas = this.searchService.date.replace(',', ' // ');
    this.anticipacion_de_compra = `${Math.round(
      this.dateService.differenceDays(this.searchService.date.split(',')[0]),
    )}`;
    this.dias_de_producto = `${Math.round(
      this.dateService.differenceDays(
        this.searchService.date.split(',')[1],
        this.searchService.date.split(',')[0],
      ),
    )}`;
    this.cantidad_de_personas = this.getCountGuest(
      this.searchService.getDecodedRooms().rooms,
    );
    this.cantidad_de_huespedes = `${this.searchService.getDecodedRooms().total}`;
    this.cantidad_de_habitaciones = `${
      this.searchService.getDecodedRooms().rooms.length
    }`;
    this.producto = this.product;
  }

  // @ts-ignore
  get product() {
    let nameProduct = 'alojamiento';
    switch (this.searchService.currentQuery.origin) {
      case '2359298': {
        nameProduct = 'disney';
        break;
      }
      case '1326681': {
        nameProduct = 'disney';
        break;
      }
      case this.universal_city: {
        nameProduct = 'universal';
        break;
      }
      default: {
        nameProduct = 'alojamiento';
        break;
      }
    }
    return nameProduct;
  }
}
